import { render, staticRenderFns } from "./Gebaeudetypen.vue?vue&type=template&id=1dfb2e10"
import script from "./Gebaeudetypen.vue?vue&type=script&lang=js"
export * from "./Gebaeudetypen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports